// extracted by mini-css-extract-plugin
export default {"tupacGrid":"rk-z","tupacHeader":"sk-z","tupacHeader2":"tk-z","tupacMenu":"uk-z","tupacMenu2":"vk-z","tupacMain":"wk-z","tupacMain2":"xk-z"};